import Data from '../Api/Data'
import PrimaryKey from '../Api/PrimaryKey'
import { Type } from 'class-transformer'
import CouponActionStatus from './CouponActionStatus'
import TK2UserLookupDM from './TK2UserLookupDM'
import TDiscountCouponDM from './TDiscountCouponDM'

export default class TSalesActionDM extends Data {
	public static className = 'TSalesActionDM'
	public static primaryKey = 'RID'
	public static systemFields = [
		'Timestamp',
	]

	public getPrimaryKey(): PrimaryKey {
		return this.RID!
	}

	Timestamp?: string
	ChangedOn?: Date
	Description?: string
	Abbr?: string
	RID?: number
	SelectionImgCalc?: string
	LegislationContextCalc?: number
	CurrentDateCalc?: Date
	CurrentTimeCalc?: Date
	SQLSequenceOrderCalc?: number
	LanguageDescriptionCalc?: string
	@Type(() => CouponActionStatus)
	StatusId?: CouponActionStatus
	@Type(() => TK2UserLookupDM)
	ChangedById?: TK2UserLookupDM
	@Type(() => TDiscountCouponDM)
	CouponChild?: TDiscountCouponDM[]
}